var filter_courses = (function( $ ) {

	var _init = function() {
		filter_attended_course();
		show_all_button();
	};

	function filter_attended_course() {
		$( '#select-attended-course' ).change( function() {
			this.form.submit();
		} );
	}

	function show_all_button() {
		$( '#show-all' ).click( function() {
			window.location.href = '/attended-courses';
			return false;
		} );
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = filter_courses;